var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8756 2.17097C60.2523 0.442184 62.79 0.68737 62.8287 2.45629L63.152 17.2958C63.5695 36.4576 77.0628 52.8371 95.7901 56.9153L110.293 60.0737C112.022 60.4503 111.777 62.988 110.008 63.0267L95.1684 63.3501C76.0067 63.7675 59.6272 77.2608 55.549 95.9881L52.3907 110.491C52.014 112.22 49.4763 111.975 49.4376 110.206L49.1143 95.3664C48.6968 76.2048 35.2035 59.8253 16.476 55.747L1.9729 52.5887C0.24411 52.2121 0.489296 49.6744 2.25822 49.6356L17.0977 49.3123C36.2595 48.8948 52.6391 35.4016 56.7173 16.6741L59.8756 2.17097Z",
    fill: "#82D965"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2);
export default __webpack_public_path__ + "static/media/b2.b350501880ba3999654a9185d17fdc6b.svg";
export { ForwardRef as ReactComponent };